module.exports = __webpack_public_path__ + "img/arlreymendez.02e3f95f.jpg";